// Wipe localStorage on logout / refresh-token failure WITHOUT clobbering
// long-lived UX preferences that should outlive a session — most notably
// the cookie-consent decision (otherwise the banner re-appears every time
// the user logs out, even after they accepted it).
//
// Add any other keys here that need to survive logout (theme, locale, etc.).

const PRESERVE_KEYS = [
  'brixlead.cookie-consent',
];

// Key PREFIXES that must survive logout. The welcome-modal "seen" flag is
// stored per-user as `brixlead:welcome:<userId>`, so we can't list an exact
// key — match by prefix. Without this, logout wiped the flag and the
// onboarding modal re-appeared on every single login (the bug this fixes).
const PRESERVE_PREFIXES = [
  'brixlead:welcome:',
];

export function clearAuthStorage() {
  const preserved: Record<string, string> = {};
  // Exact-match preserves.
  for (const k of PRESERVE_KEYS) {
    const v = localStorage.getItem(k);
    if (v !== null) preserved[k] = v;
  }
  // Prefix-match preserves (per-user onboarding flags, etc.).
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && PRESERVE_PREFIXES.some((p) => k.startsWith(p))) {
      const v = localStorage.getItem(k);
      if (v !== null) preserved[k] = v;
    }
  }
  localStorage.clear();
  for (const [k, v] of Object.entries(preserved)) {
    localStorage.setItem(k, v);
  }
}
